import { useCreateRoleMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useAddRoleHandler() {
	const [ createRole ] = useCreateRoleMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( name: string, spendingLimit?: number ) => {
		const { data } = await createRole( { variables: { name, spendingLimit } } )
		if ( data?.createRole?.success ) {
			showSuccess( `addRoleSuccess${Date.now()}`, data?.createRole?.message ?? 'Successfully created role!' )
		} else {
			showError( `addRoleError${Date.now()}`, data?.createRole?.message ?? 'Sorry, an error occurred' )
		}
	}
}
